import React from 'react';

const TableOfContents = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 22.9 16.357"
			className={className}
		>
			<g transform="translate(22.9 16.357) rotate(180)">
				<path
					d="M15.867,75H.491A.528.528,0,0,0,0,75.491v2.29a.528.528,0,0,0,.491.491H15.867a.528.528,0,0,0,.491-.491v-2.29A.528.528,0,0,0,15.867,75"
					transform="translate(0 -68.457)"
				/>
				<path
					d="M227.781,75h-2.29a.528.528,0,0,0-.491.491v2.29a.528.528,0,0,0,.491.491h2.29a.528.528,0,0,0,.491-.491v-2.29a.528.528,0,0,0-.491-.491"
					transform="translate(-205.371 -68.457)"
				/>
				<path
					d="M15.867,150H.491a.528.528,0,0,0-.491.491v2.29a.528.528,0,0,0,.491.491H15.867a.528.528,0,0,0,.491-.491v-2.29a.528.528,0,0,0-.491-.491"
					transform="translate(0 -136.914)"
				/>
				<path
					d="M227.781,150h-2.29a.528.528,0,0,0-.491.491v2.29a.528.528,0,0,0,.491.491h2.29a.528.528,0,0,0,.491-.491v-2.29a.528.528,0,0,0-.491-.491"
					transform="translate(-205.371 -136.914)"
				/>
				<path d="M15.867,0H.491A.528.528,0,0,0,0,.491v2.29a.528.528,0,0,0,.491.491H15.867a.528.528,0,0,0,.491-.491V.491A.528.528,0,0,0,15.867,0" />
				<path
					d="M227.781,0h-2.29A.528.528,0,0,0,225,.491v2.29a.528.528,0,0,0,.491.491h2.29a.528.528,0,0,0,.491-.491V.491A.528.528,0,0,0,227.781,0"
					transform="translate(-205.371)"
				/>
			</g>
		</svg>
	);
};

export default TableOfContents;
